import Lara from "@/presets/lara";

export const detailModalPresets = {
  ...Lara,
  viewButton: {
    ...Lara.button,
    label: { class: ["uppercase", "text-base"] },
  },
};
